import _, { cloneDeep, groupBy, round, isArray } from 'lodash';
import { usePlanningActualState } from '../Context/index';
import { checkArray, roundOff } from '../../../Components/helper';

export default function useCalculationHooks() {
  const {
    setPlanningActual,
    planningActual: { staticFields, overAllColumnValues },
  } = usePlanningActualState();
  const { isPlannedSales, isActualSales } = overAllColumnValues;

  const calculateColumnsValues = async (state, overallTot) => {
    const copyState = state;
    const activePlannedSales = overallTot ? overallTot?.isPlannedSales : isPlannedSales;
    const activeActualSales = overallTot ? overallTot?.isActualSales : isActualSales;
    let copyOverAllColumnValues = overallTot ? cloneDeep(overallTot) : cloneDeep(overAllColumnValues);
    if (checkArray(copyState?.category)) {
      if (activePlannedSales && activeActualSales) {
        if (overallTot) {
          copyOverAllColumnValues = Object.assign(await getOverAllColumnValues(copyState.category), overallTot);
        } else {
          copyOverAllColumnValues = Object.assign(copyOverAllColumnValues, await getOverAllColumnValues(copyState.category));
        }
      }
      if (!activePlannedSales && !activeActualSales) {
        if (overallTot) {
          copyOverAllColumnValues = {
            ...overallTot,
            ...(await getOverAllColumnValues(copyState.category, 'plannedSales')),
          };
          copyOverAllColumnValues.plannedSales = overallTot.plannedSales;
          copyOverAllColumnValues.actualSales = overallTot.actualSales;
        } else {
          const updatedObj = await getOverAllColumnValues(copyState.category, 'plannedSales');
          updatedObj.plannedSales = copyOverAllColumnValues.plannedSales;
          updatedObj.actualSales = copyOverAllColumnValues.actualSales;

          updatedObj.isPlannedSales = copyOverAllColumnValues.isPlannedSales;
          updatedObj.isActualSales = copyOverAllColumnValues.isActualSales;
          copyOverAllColumnValues = updatedObj;
        }
      } else if (!activePlannedSales && activeActualSales) {
        let copiedOverTot = overallTot || copyOverAllColumnValues;
        if (overallTot) {
          copiedOverTot = await getOverAllColumnValues(copyState.category, 'plannedSales');
          copiedOverTot.actualSales = overallTot.actualSales;
          copiedOverTot.plannedSales = overallTot.plannedSales;
        } else {
          copiedOverTot = await getOverAllColumnValues(copyState.category, 'plannedSales');
          copiedOverTot.plannedSales = copyOverAllColumnValues.plannedSales;
        }
        copiedOverTot.isPlannedSales = copyOverAllColumnValues.isPlannedSales;
        copiedOverTot.isActualSales = copyOverAllColumnValues.isActualSales;
        copyOverAllColumnValues = copiedOverTot;
      } else if (activePlannedSales && !activeActualSales) {
        let copiedOverTot = overallTot || copyOverAllColumnValues;
        if (overallTot) {
          copiedOverTot = await getOverAllColumnValues(copyState.category, 'actualSales');
          copiedOverTot.actualSales = overallTot.actualSales;
          copiedOverTot.plannedSales = overallTot.plannedSales;
        } else {
          copiedOverTot = await getOverAllColumnValues(copyState.category, 'actualSales');
          copiedOverTot.actualSales = copyOverAllColumnValues.actualSales;
        }
        copiedOverTot.isPlannedSales = copyOverAllColumnValues.isPlannedSales;
        copiedOverTot.isActualSales = copyOverAllColumnValues.isActualSales;
        copyOverAllColumnValues = copiedOverTot;
      }
      const manipulatedCategory = [];
      if (isArray(copyState?.category) && copyState?.category?.length > 0) {
        for (const value of copyState.category) {
          // get total of each category
          const manipulatedSubCat = [];
          if (checkArray(value?.subcategory)) {
            for (const subValue of value.subcategory) {
              const subObj = subValue;
              for (const col of staticFields) {
                switch (col.keyName) {
                  case 'plannedSales':
                    if (activePlannedSales) {
                      subObj.plannedMix = await getPlannedMixValues(subObj, copyOverAllColumnValues, 'plannedSales');
                    }
                    break;

                  case 'actualSales':
                    if (activeActualSales) {
                      subObj.actualMix = await getActualMixValues(subObj, copyOverAllColumnValues, 'actualSales');
                    }
                    break;

                  case 'plannedMix':
                    if (!activePlannedSales) {
                      subObj.plannedSales = await getPlannedSalesValues(subObj, copyOverAllColumnValues, 'plannedMix');
                    }
                    break;

                  case 'actualMix':
                    if (!activeActualSales) {
                      subObj.actualSales = await getActualSalesValues(subObj, copyOverAllColumnValues, 'actualMix');
                    }
                    break;

                  case 'plannedASP':
                    subObj.plannedASP = await getPlannedASP(subObj);
                    break;
                  case 'actualASP':
                    subObj.actualASP = await getActualASP(subObj);
                    break;
                  case 'plannedSPO':
                    subObj.plannedSPO = await getPlannedSPO(subObj);
                    break;
                  case 'actualSPO':
                    subObj.actualSPO = await getActualSPO(subObj);
                    break;
                  case 'plannedCOS':
                    subObj.plannedMarkdown = await getPlannedMarkdown(subObj);
                    subObj.plannedCOS = await getPlannedCOS(subObj);
                    break;
                  case 'actualCOS':
                    subObj.actualMarkdown = await getActualMarkdown(subObj);
                    subObj.actualCOS = await getActualCOS(subObj);
                    break;
                  case 'plannedMarginRate':
                    subObj.plannedCashMargin = await getPlannedMargin(subObj);
                    subObj.plannedMarginRate = await getPlannedMarginRate(subObj);
                    break;
                  case 'actualMarginRate':
                    subObj.actualCashMargin = await getActualMargin(subObj);
                    subObj.actualMarginRate = await getActualMarginRate(subObj);
                    break;
                  case 'plannedCashMargin':
                    subObj.plannedCashMargin = await getPlannedMargin(subObj);
                    break;
                  case 'actualCashMargin':
                    subObj.actualCashMargin = await getActualMargin(subObj);
                    break;
                  case 'plannedMarkdown':
                    subObj.plannedMarkdown = await getPlannedMarkdown(subObj);
                    break;
                  case 'actualMarkdown':
                    subObj.actualMarkdown = await getActualMarkdown(subObj);
                    break;
                  default:
                    break;
                }
              }
              const inputTypeFields = staticFields?.filter((cl) => cl.type === 'input')?.map((vl) => vl.keyName);
              inputTypeFields?.forEach((key) => {
                if (!subObj.hasOwnProperty(key)) {
                  subObj[key] = 0; // default value
                }
              });
              manipulatedSubCat.push(subObj);
            }
          }

          value.subcategory = manipulatedSubCat;
          manipulatedCategory.push(value);
        }
      }
      await getOverAllColumnValues(manipulatedCategory, ['plannedSales', 'actualSales']);
      copyState.category = manipulatedCategory;
    }
    let ignoredColumnsCalcTot = copyOverAllColumnValues;
    const eachColumnsTotals = await getEachColumnsTotal(copyState?.category);

    ignoredColumnsCalcTot.actualSales = copyOverAllColumnValues.actualSales;
    ignoredColumnsCalcTot.plannedSales = copyOverAllColumnValues.plannedSales;
    ignoredColumnsCalcTot.isPlannedSales = copyOverAllColumnValues.isPlannedSales;
    ignoredColumnsCalcTot.isActualSales = copyOverAllColumnValues.isActualSales;
    const manipulateKeysValues = await getCalculatedPercentageFields(ignoredColumnsCalcTot);
    ignoredColumnsCalcTot = Object.assign(ignoredColumnsCalcTot, manipulateKeysValues);
    setPlanningActual((prevState) => ({
      ...prevState,
      modifiedData: { ...copyState },
      overAllColumnValues: { ...ignoredColumnsCalcTot },
      eachColumnsTotals,
    }));
    return {
      overallTotal: ignoredColumnsCalcTot,
      allCategoryData: { ...copyState },
    };
  };

  const getOverAllColumnValues = async (catArr, keyToStopCal) => {
    const obj = {};
    const copyState = cloneDeep(catArr);
    for (const columns of staticFields) {
      obj[columns.keyName] = '0';
      for (const element of copyState) {
        if (element?.subcategory?.length > 0) {
          for (const subElement of element.subcategory) {
            const columnValues = subElement[columns.keyName] || '0';
            if (checkArray(keyToStopCal)) {
              if (!keyToStopCal.includes(columns.keyName)) {
                if (obj.hasOwnProperty(columns.keyName)) {
                  obj[columns.keyName] = roundOff(Number(obj[columns.keyName]) + Number(columnValues), 2);
                } else {
                  obj[columns.keyName] = roundOff(Number(columnValues), 2);
                }
              } else obj[columns.keyName] = columnValues;
            } else if (keyToStopCal !== columns.keyName) {
              if (obj.hasOwnProperty(columns.keyName)) {
                obj[columns.keyName] = roundOff(Number(obj[columns.keyName]) + Number(columnValues), 2);
              } else {
                obj[columns.keyName] = roundOff(Number(columnValues), 2);
              }
            } else obj[columns.keyName] = roundOff(Number(columnValues), 2);
          }
        }
      }
    }

    return obj;
  };

  const getEachColumnsTotal = async (catArr) => {
    const eachColumnsTot = [];

    for (const cat of catArr) {
      let obj = {
        _id: cat?.categoryId?._id,
      };
      for (const columns of staticFields) {
        obj[columns.keyName] = '0';
        obj[columns.keyName] = _.sumBy(cat?.subcategory, (item) => {
          return Number(item[columns.keyName]) ? Number(item[columns.keyName]) : 0;
        });
      }
      const manipulateKeysValues = await getCalculatedPercentageFields(obj);
      obj = Object.assign(obj, manipulateKeysValues);
      eachColumnsTot.push(obj);
    }
    return groupBy(eachColumnsTot, '_id');
  };

  const getPlannedMixValues = async (subCatObj, overalltotal, keyName) => {
    const plannedSales = subCatObj[keyName] || '0';
    const overTotValue = overalltotal[keyName] || '0';
    const plannedMixValues = ((plannedSales / overTotValue) * 100).toString();
    return Number.isNaN(plannedMixValues) ? '0' : roundOff(plannedMixValues, 2);
  };

  const getActualMixValues = async (subCatObj, overalltotal, keyName) => {
    const actualSales = subCatObj[keyName] || '0';
    const overTotValue = overalltotal[keyName] || '0';
    const actualMixValue = ((actualSales / overTotValue) * 100).toString();
    return Number.isNaN(actualMixValue) ? '0' : roundOff(actualMixValue, 2);
  };

  const getPlannedSalesValues = async (subCatObj, overalltotal, keyName) => {
    const plannedMix = subCatObj[keyName] || '0';
    const overTotValue = overalltotal.plannedSales || '0';
    const plannedSalesValue = ((plannedMix * overTotValue) / 100).toString();
    return Number.isNaN(plannedSalesValue) ? '0' : round(plannedSalesValue, 0);
  };

  const getActualSalesValues = async (subCatObj, overalltotal, keyName) => {
    const actualMix = subCatObj[keyName] || '0';
    const overTotValue = overalltotal.actualSales || '0';
    const actualSalesValue = ((actualMix * overTotValue) / 100).toString();
    return Number.isNaN(actualSalesValue) ? '0' : round(actualSalesValue, 0);
  };

  const getPlannedASP = async (subCatObj) => {
    const plannedSales = subCatObj?.plannedSales || '0';
    const plannedSalesUnit = subCatObj?.plannedSalesUnit || '0';
    const plannedASPValue = (plannedSales / plannedSalesUnit).toString();
    return Number.isNaN(plannedASPValue) || plannedASPValue === 'Infinity' ? '0' : roundOff(plannedASPValue, 2);
  };

  const getActualASP = async (subCatObj) => {
    const actualSales = subCatObj?.actualSales || '0';
    const actualSalesUnit = subCatObj?.actualSalesUnit || '0';
    const actualASPValue = (actualSales / actualSalesUnit).toString();
    return Number.isNaN(actualASPValue) || actualASPValue === 'Infinity' ? '0' : roundOff(actualASPValue, 2);
  };

  const getPlannedSPO = async (subCatObj) => {
    const plannedSales = subCatObj?.plannedSales || '0';
    const plannedOption = subCatObj?.plannedOption || '0';
    const plannedSPO = (plannedSales / plannedOption).toString();
    return Number.isNaN(plannedSPO) || plannedSPO === 'Infinity' ? '0' : roundOff(plannedSPO, 2);
  };

  const getActualSPO = async (subCatObj) => {
    const actualSales = subCatObj?.actualSales || '0';
    const actualOption = subCatObj?.actualOption || '0';
    const actualSPO = (actualSales / actualOption).toString();
    return Number.isNaN(actualSPO) || actualSPO === 'Infinity' ? '0' : roundOff(actualSPO, 2);
  };

  const getPlannedCOS = async (subCatObj) => {
    const plannedSales = subCatObj?.plannedSales || '0';
    const plannedMarkdown = subCatObj?.plannedMarkdown || '0';
    const plannedBuyingMargin = subCatObj?.plannedBuyingMargin || '0';
    const plannedCOS = ((Number(plannedSales) + Number(plannedMarkdown)) * (1 - Number(plannedBuyingMargin / 100))).toString();

    return Number.isNaN(plannedCOS) || plannedCOS === 'Infinity' ? '0' : roundOff(plannedCOS, 2);
  };

  const getActualCOS = async (subCatObj) => {
    const actualSales = subCatObj?.actualSales || '0';
    const actualMarkdown = subCatObj?.actualMarkdown || '0';
    const actualBuyingMargin = subCatObj?.actualBuyingMargin || '0';
    const actualCOS = ((Number(actualSales) + Number(actualMarkdown)) * (1 - Number(actualBuyingMargin / 100))).toString();
    return Number.isNaN(actualCOS) || actualCOS === 'Infinity' ? '0' : roundOff(actualCOS, 2);
  };

  const getPlannedMarginRate = async (subCatObj) => {
    const plannedSales = subCatObj?.plannedSales || '0';
    const plannedCashMargin = subCatObj?.plannedCashMargin || '0';
    const plannedMarginRate = ((plannedCashMargin / plannedSales) * 100).toString();
    return Number.isNaN(plannedMarginRate) || plannedMarginRate === 'Infinity' ? '0' : roundOff(plannedMarginRate, 2);
  };

  const getActualMarginRate = async (subCatObj) => {
    const actualSales = subCatObj?.actualSales || '0';
    const actualCashMargin = subCatObj?.actualCashMargin || '0';
    const actualMarginRate = ((actualCashMargin / actualSales) * 100).toString();
    return Number.isNaN(actualMarginRate) || actualMarginRate === 'Infinity' ? '0' : roundOff(actualMarginRate, 2);
  };

  const getPlannedMargin = async (subCatObj) => {
    const plannedSales = subCatObj?.plannedSales || '0';
    const plannedMarkdown = subCatObj?.plannedMarkdown || '0';
    const plannedBuyingMargin = subCatObj?.plannedBuyingMargin || '0';
    const plannedCOS = (Number(plannedSales) + Number(plannedMarkdown)) * (1 - Number(plannedBuyingMargin / 100));
    const plannedMargin = (Number(plannedSales) - Number(plannedCOS)).toString();
    return Number.isNaN(plannedMargin) || plannedMargin === 'Infinity' ? '0' : roundOff(plannedMargin, 2);
  };

  const getActualMargin = async (subCatObj) => {
    const actualSales = subCatObj?.actualSales || '0';
    const actualMarkdown = subCatObj?.actualMarkdown || '0';
    const actualBuyingMargin = subCatObj?.actualBuyingMargin || '0';
    const actualCOS = (Number(actualSales) + Number(actualMarkdown)) * (1 - Number(actualBuyingMargin / 100));
    const actualMargin = (Number(actualSales) - Number(actualCOS)).toString();
    return Number.isNaN(actualMargin) || actualMargin === 'Infinity' ? '0' : roundOff(actualMargin, 2);
  };

  const getPlannedMarkdown = async (subCatObj) => {
    const plannedSales = subCatObj?.plannedSales || '0';
    const plannedMarkdownPer = subCatObj?.plannedMarkdownPer || '0';
    const plannedMarkdown = ((plannedMarkdownPer / 100) * plannedSales).toString();
    return Number.isNaN(plannedMarkdown) || plannedMarkdown === 'Infinity' ? '0' : roundOff(plannedMarkdown, 2);
  };

  const getActualMarkdown = async (subCatObj) => {
    const actualSales = subCatObj?.actualSales || '0';
    const actualMarkdownPer = subCatObj?.actualMarkdownPer || '0';
    const actualMarkdown = ((actualMarkdownPer / 100) * actualSales).toString();
    return Number.isNaN(actualMarkdown) || actualMarkdown === 'Infinity' ? '0' : roundOff(actualMarkdown, 2);
  };

  const manipulateSubCategory = async (value, keyName, overAllColumn) => {
    const manipulatedSubCat = [];
    if (value?.subcategory?.length > 0) {
      for (const subValue of value.subcategory) {
        const subObj = { ...subValue };
        if (keyName === 'plannedSales') {
          subObj.plannedMix = await getPlannedSalesValues(subObj, overAllColumn, 'plannedSales');
        } else if (keyName === 'actualSales') {
          subObj.actualMix = await getActualSalesValues(subObj, overAllColumn, 'actualSales');
        }
        manipulatedSubCat.push(subObj);
      }
      value.subcategory = [...manipulatedSubCat];
    }
    return value;
  };

  const setValuesBasesOnToggleMixToSales = async (state, keyName, curreOverAllTot) => {
    const copyState = state;
    let overAllColumn = await getOverAllColumnValues(copyState?.category);

    const manipulatedCategory = [];
    if (copyState?.category?.length > 0) {
      for (const value of copyState.category) {
        manipulatedCategory.push(await manipulateSubCategory(value, keyName, overAllColumn));
      }
    }
    copyState.category = [...manipulatedCategory];

    overAllColumn = Object.assign(overAllColumn, await getOverAllColumnValues(copyState?.category));
    overAllColumn.isPlannedSales = curreOverAllTot.isPlannedSales;
    overAllColumn.isActualSales = curreOverAllTot.isActualSales;
    overAllColumn.plannedSales = curreOverAllTot.plannedSales;
    overAllColumn.actualSales = curreOverAllTot.actualSales;
    await calculateColumnsValues(copyState, overAllColumn);
  };

  const calculateValuesWhenOverTotalSalesChanges = async (state, updatedoverAllTotal) => {
    const copyState = state;
    const manipulatedCategory = [];
    if (copyState?.category?.length > 0) {
      for (const value of copyState.category) {
        const manipulatedSubCat = [];
        if (value?.subcategory?.length > 0) {
          for (const subValue of value.subcategory) {
            const subObj = { ...subValue };
            subObj.plannedSales = await getPlannedSalesValues(subObj, updatedoverAllTotal, 'plannedMix');
            subObj.actualSales = await getActualSalesValues(subObj, updatedoverAllTotal, 'actualMix');
            manipulatedSubCat.push(subObj);
          }
          value.subcategory = manipulatedSubCat;
        }
        manipulatedCategory.push(value);
      }
    }
    copyState.category = manipulatedCategory;
    await calculateColumnsValues(copyState, updatedoverAllTotal);
  };

  const checkLimitOfHundred = async (state, keyName) => {
    const copyState = { ...state };
    const category = copyState?.category;
    let sumOfMixColumn = 0;
    for (const cat of category) {
      sumOfMixColumn += _.sumBy(cat?.subcategory, (item) => {
        return Number(item[keyName]) ? Number(item[keyName]) : 0;
      });
    }
    return sumOfMixColumn > 100;
  };

  const calcualteVsDAta = async (main, compare) => {
    if (main) {
      const vsDAta = [];
      if (main?.category?.length > 0) {
        for (const mainData of main.category) {
          if (mainData?.subcategory?.length > 0) {
            for (const subMaindata of mainData.subcategory) {
              const mainSubCatValues = subMaindata.plannedSales;
              const mainSubCatSalesUnitValues = subMaindata.plannedSalesUnit;
              const mainSubCatOptionValues = subMaindata.plannedOption;
              for (const comMianData of compare) {
                const category = comMianData?.category.find((val) => val?.categoryId._id === mainData?.categoryId._id);
                if (category) {
                  const subCAt = category?.subcategory.find((val) => val?.subcategoryId?._id === subMaindata?.subcategoryId?._id);
                  if (subCAt) {
                    const planValue = subCAt.actualSales;
                    const planSalesValue = subCAt.actualSalesUnit;
                    const planOptionValue = subCAt.actualOption;
                    const salesValue = Number(mainSubCatValues) / Number(planValue);
                    const salesUnitValue = Number(mainSubCatSalesUnitValues) / Number(planSalesValue);
                    const optionValue = Number(mainSubCatOptionValues) / Number(planOptionValue);
                    const obj = {
                      year: comMianData?.year,
                      subcategoryId: subCAt?.subcategoryId,
                      mainCategory: category?.categoryId,
                      vsSalesItem: !isFinite(salesValue) ? 0 : (salesValue - 1) * 100,
                      vsSalesUnitItem: !isFinite(salesUnitValue) ? 0 : (salesUnitValue - 1) * 100,
                      vsOptionItem: !isFinite(optionValue) ? 0 : (optionValue - 1) * 100,
                    };
                    vsDAta.push(obj);
                  }
                }
              }
            }
          }
        }
      }
      setPlanningActual((prevState) => ({
        ...prevState,
        vsDataContext: vsDAta,
      }));
    }
  };

  const getCalculatedPercentageFields = async (obj) => {
    const newObj = { ...obj };
    const plannedCostOfSales = newObj?.plannedCOS || 0;
    const actualCostOfSales = newObj?.actualCOS || 0;
    const plannedMarkDown = newObj?.plannedMarkdown || 0;
    const actualMarkDown = newObj?.actualMarkdown || 0;
    const plannedSales = newObj?.plannedSales || 0;
    const actualSales = newObj?.actualSales || 0;
    const plannedBuyingMargin = roundOff((1 - plannedCostOfSales / (plannedMarkDown + plannedSales)) * 100);
    const actualBuyingMargin = roundOff((1 - actualCostOfSales / (actualMarkDown + actualSales)) * 100);
    const plannedMarginRate = roundOff((1 - plannedCostOfSales / plannedSales) * 100);
    const actualMarginRate = roundOff((1 - actualCostOfSales / actualSales) * 100);
    const plannedMarkdownPer = roundOff((plannedMarkDown / plannedSales) * 100);
    const actualMarkdownPer = roundOff((actualMarkDown / actualSales) * 100);
    newObj.plannedBuyingMargin = Number.isFinite(plannedBuyingMargin) ? plannedBuyingMargin : 0;
    newObj.actualBuyingMargin = Number.isFinite(actualBuyingMargin) ? actualBuyingMargin : 0;
    newObj.plannedMarginRate = Number.isFinite(plannedMarginRate) ? plannedMarginRate : 0;
    newObj.actualMarginRate = Number.isFinite(actualMarginRate) ? actualMarginRate : 0;
    newObj.plannedMarkdownPer = Number.isFinite(plannedMarkdownPer) ? plannedMarkdownPer : 0;
    newObj.actualMarkdownPer = Number.isFinite(actualMarkdownPer) ? actualMarkdownPer : 0;
    return newObj;
  };
  return {
    calculateColumnsValues,
    setValuesBasesOnToggleMixToSales,
    calculateValuesWhenOverTotalSalesChanges,
    checkLimitOfHundred,
    calcualteVsDAta,
  };
}
